module.exports = __webpack_public_path__ + "static/media/meeting-edit-empty.64a7ea84.jpg";